export var EventCategory;
(function (EventCategory) {
    EventCategory["ACTION_TRACKING"] = "Action Tracking";
    EventCategory["USER_ENGAGEMENT"] = "User Engagement";
})(EventCategory || (EventCategory = {}));
